import { createAction } from 'redux-actions';

export const setSubmission = createAction('SET_SUBMISSION');
export const setSubmissionConversation = createAction('SET_SUBMISSION_CONVERSATION');
export const setSubmissionNotes = createAction('SET_SUBMISSION_NOTES');